import { useEffect } from 'react';

/**
 * ScrollToTop component - Scrolls window to top whenever the view changes
 * This ensures every page/component navigation starts at the top of the page
 */
export function ScrollToTop({ view }) {
    useEffect(() => {
        // Scroll to top immediately when view changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant' // Use instant for immediate scroll, or 'smooth' for animated
        });
    }, [view]); // Re-run whenever view changes

    return null; // This component doesn't render anything
}
